import {
  SET_WEBSITE_SETTINGS,
  SET_WEBSITE_STYLES,
  UPDATE_WEBSITE_STYLES_TYPOGRAPHY_PARAGRAPH,
  SET_WEBSITE_THEME,
  SET_WEBSITE_DRAFT_THEME,
  SET_WEBSITE_THEMES_LIST,
  UPDATE_WEBSITE_STYLES_TYPOGRAPHY_HEADING,
  UPDATE_WEBSITE_STYLES_PRIMARY_BUTTONS_TYPOGRAPHY,
} from './website-settings-action-type'

import {
  WebsiteFontSettingsInterface,
  WebsiteSettingsInterface,
  WebsiteStylesInterface,
  WebsiteThemeInterface,
  WebsiteThemeListInterface,
  WebsiteTypographySettingsStylesInterface,
} from './website-settings-types'

import {
  WebsiteSettingsAction,
  WebsiteStylesAction,
  WebsiteThemeAction,
  WebsiteDraftThemeAction,
  WebsiteThemeListAction,
  WebsiteStylesTypographyParagraphAction,
  WebsiteStylesTypographyHeadingAction,
  WebsiteStylesPrimaryButtonsTypographyAction,
} from './website-settings-reducer'
import { AppDispatch } from 'client/store'

export const setWebsiteStyles = (
  styles: WebsiteStylesInterface,
): WebsiteStylesAction => ({
  type: SET_WEBSITE_STYLES,
  payload: styles,
})

export const updateWebsiteStylesParagraphTypography = <
  T extends WebsiteTypographySettingsStylesInterface,
>(
  typography: T,
): WebsiteStylesTypographyParagraphAction<T> => ({
  type: UPDATE_WEBSITE_STYLES_TYPOGRAPHY_PARAGRAPH,
  payload: typography,
})

export const updateWebsiteStylesHeadingTypography = <
  T extends WebsiteTypographySettingsStylesInterface,
>(
  typography: T,
): WebsiteStylesTypographyHeadingAction<T> => ({
  type: UPDATE_WEBSITE_STYLES_TYPOGRAPHY_HEADING,
  payload: typography,
})

export const updateWebsiteStylesPrimaryButtonsTypography = <
  T extends WebsiteFontSettingsInterface,
>(
  typography: T,
): WebsiteStylesPrimaryButtonsTypographyAction<T> => ({
  type: UPDATE_WEBSITE_STYLES_PRIMARY_BUTTONS_TYPOGRAPHY,
  payload: typography,
})

export const setWebsiteTheme = (
  theme: WebsiteThemeInterface,
): WebsiteThemeAction => ({
  type: SET_WEBSITE_THEME,
  payload: theme,
})

export const setWebsiteDraftTheme = (
  theme: WebsiteThemeInterface,
): WebsiteDraftThemeAction => ({
  type: SET_WEBSITE_DRAFT_THEME,
  payload: theme,
})

export const setWebsiteThemesList = (
  themes: WebsiteThemeListInterface[],
): WebsiteThemeListAction => ({
  type: SET_WEBSITE_THEMES_LIST,
  payload: themes,
})

export const setWebsiteSettings = (
  website: WebsiteSettingsInterface,
): WebsiteSettingsAction => ({
  type: SET_WEBSITE_SETTINGS,
  payload: website,
})

export const fetchWebsiteDraftTheme =
  (theme: WebsiteThemeInterface) => async (dispatch: AppDispatch) => {
    dispatch(setWebsiteDraftTheme(theme))
  }
